import { enqueueSnackbar } from 'notistack';

export const notificationMiddleware = _api => next => action => {
  const { arg, requestStatus } = action.meta ?? {};
  const fulfilledNotification = arg?.originalArgs?.fulfilledNotification;

  if (requestStatus === 'fulfilled' && !!fulfilledNotification)
    enqueueSnackbar(action.meta.arg.originalArgs.fulfilledNotification, {
      severity: 'success',
    });

  return next(action);
};
